if (!customElements.get('refurbished-landing-shop')) {
    customElements.define(
        'refurbished-landing-shop',
        class extends HTMLElement {
            connectedCallback() {
                this.initElements();
                // this.initTabSwiper();  //情人不需要切换品类，只需要切换到具体颜色的产品，所以注释掉此方法
                window.addEventListener('DOMContentLoaded', () => {
                    this.initTabs();
                });
            }

            /**
             * Initialize elements and move blocks to the appropriate containers.
             */
            initElements() {
                const blocks = this.querySelectorAll('[data-refurbished-shop-block]');
                const tabs = this.querySelector('[data-to-refurbished-shop-tabs]');
                const groups = this.querySelector('[data-to-refurbished-shop-products-groups]');
                for (const block of blocks) {
                    const tab = block.querySelector('[data-refurbished-shop-tab]');
                    const products = block.querySelector('[data-refurbished-shop-products]');
                    tabs.append(tab);
                    groups.append(products);
                }
            }

            /**
             * Change active tab and display corresponding products group.
             * @param {String} tabHandle - The tab handle name.
             */
            changeTab(tabHandle) {
                this.querySelector('[data-refurbished-shop-tab].active')?.classList.remove('active');
                const tab = this.querySelector(`[data-refurbished-shop-tab="${tabHandle}"]`);
                const productsGroups = this.querySelectorAll('[data-refurbished-shop-products]');

                tab?.classList.add('active');

                const targetGroup = this.querySelector(
                    `[data-refurbished-shop-products="${tab.dataset.refurbishedShopTab}"]`
                );
                for (const group of productsGroups) {
                    group.style.display = 'none';
                }
                if (targetGroup) {
                    this.innitToggleBtns(targetGroup);
                    this.initProductTabList(targetGroup);
                    this.innitTargetGroup(targetGroup);
                    targetGroup.style.display = 'block';
                }

                this.initProductSwiper(targetGroup);
            }

            innitTargetGroup(targetGroup) {
                const slideItmes = targetGroup.querySelectorAll('.valentines-product-swiper .swiper-slide')
                slideItmes.forEach(item => {
                    const variants = item.querySelectorAll('.refurbished-landing-shop__product');
                    variants.forEach((variant, index) => {
                        if (index !== 0) {
                            variant.style.display = 'none';
                        } else {
                            variant.style.display = 'flex';
                        }

                        const varaintId = variant.getAttribute("data-varint-id");
                        const toggleBtns = variant.querySelectorAll('.toggle-btn');
                        toggleBtns.forEach(btn => {
                            if (btn.getAttribute('data-block-id').includes(varaintId)) {
                                btn.classList.add('active');
                            }
                        })
                    })
                })
            }

            innitToggleBtns(targetGroup) {
                const toggleBtnsGroup = targetGroup.querySelectorAll(".swiper-slide>.toggle-btns");
                // 切换Tab的时候会重新计算DOM组，因为第一次生成颜色切换按钮就已经把toggle-btns移除了，所以切换tab后不需要再执行以下操作
                if (toggleBtnsGroup.length === 0) return;
                toggleBtnsGroup.forEach(btnsGroup => {
                    const varaints = btnsGroup.parentElement.querySelectorAll(".refurbished-landing-shop__product");

                    // 只有一种颜色的产品时，不操作
                    if ([...varaints].length < 2) return;
                    varaints.forEach((varaint, vindex) => {
                        const varaintId = varaint.getAttribute("data-varint-id");
                        const varaintColor = varaint.getAttribute("data-variant-color");
                        const btns = btnsGroup.querySelectorAll('.toggle-btn');
                        btns.forEach((btn, bindex) => {
                            if (btn.getAttribute('data-block-id').includes(varaintId)) {
                                btn.style = `--bcolor:${varaintColor};`
                            }
                        })
                    })
                })

                toggleBtnsGroup.forEach(btnsGroup => {
                    const varaints = btnsGroup.parentElement.querySelectorAll(".refurbished-landing-shop__product");
                    // 只有一种颜色的产品时，不操作
                    if ([...varaints].length < 2) return;
                    varaints.forEach((varaint, vindex) => {
                        const togglegroup = varaint.querySelector('.toggle-group');
                        const element = btnsGroup.cloneNode(true);
                        togglegroup.appendChild(element);
                    })
                })

                // Remove original toggleBtnsGroup from DOM Tree
                // 删掉liquid生成的toggle-btns，生成toggle-btns的文件是_valentines-day-shop-product.liquid
                toggleBtnsGroup.forEach(btnsGroup => {
                    btnsGroup.remove();
                })

                const slideItem = targetGroup.querySelectorAll('.valentines-product-swiper>.swiper-slide');
                slideItem.forEach(item => {
                    const varaints = item.querySelectorAll('.refurbished-landing-shop__product');
                    varaints.forEach(varaint => {
                        const toggleBtns = varaint.querySelectorAll('.toggle-btn');
                        toggleBtns.forEach(btn => {

                            btn.addEventListener('click', () => {
                                varaints.forEach(el => {
                                    el.style.display = "none";
                                    const varaintId = el.getAttribute('data-varint-id');
                                    if (btn.getAttribute('data-block-id').includes(varaintId)) {
                                        el.style.display = 'flex';
                                    }
                                })
                            })
                        })
                    })
                })




            }

            /**
             * Initialize tabs and set up click event listeners.
             */
            initTabs() {
                const tabs = this.querySelectorAll('[data-refurbished-shop-tab]');
                for (const tab of tabs) {
                    tab.addEventListener('click', () => {
                        this.changeTab(tab.dataset.refurbishedShopTab);
                    });
                }

                // Activate the first tab by default
                if (tabs.length > 0) {
                    tabs[0].click();
                }
            }
            /**
             * Initialize Swiper for tabs.
             * 情人不需要切换品类，只需要切换到具体颜色的产品，所以注释掉此方法
             */
            initTabSwiper() {
                const tabSwiperElement = this.querySelector('[data-to-refurbished-shop-tabs-swiper]');
                this.tabSwiper = new Swiper(tabSwiperElement, {
                    slidesPerView: "auto",
                    spaceBetween: 0,
                    slidesPerGroup: 1,
                    slideClass: 'refurbished-landing-shop__tab',
                    direction: "horizontal",
                    loop: false,
                    navigation: {
                        nextEl: tabSwiperElement.querySelector('.refurbished-swiper-tab-button-next'),
                        prevEl: tabSwiperElement.querySelector('.refurbished-swiper-tab-button-prev'),
                    },
                });
            }

            /**
             * Initialize Swiper for products group.
             * @param {HTMLElement} groupElement - The products group element.
             */
            initProductSwiper(groupElement) {
                if (this.mySwiper) {
                    this.mySwiper.destroy();
                }
                this.mySwiper = new Swiper(groupElement.querySelector('.refurbished-landing-shop__swiper.swiper'), {
                    normalizeSlideIndex: false,
                    slidesPerView: 1.05,
                    spaceBetween: 24,
                    loop: false,
                    pagination: {
                        el: groupElement.querySelector('.refurbished-landing-shop__products>.common-wrapper>.swiper-pagination'),
                        clickable: true,
                    },
                    breakpoints: {
                        850: {
                            slidesPerView: 1.1,
                            spaceBetween: 16,
                        }
                    },
                    on: {
                        slideChangeTransitionEnd: function () {
                            const el = document.querySelector('refurbished-landing-shop');
                            const swiper = el && el.productTabSwiper; // 可能为 null，需判空
                            const tabs = el && el.querySelectorAll('[data-vd-product-tab-name]');
                            if (tabs && tabs.length > 0) {
                                let index = this.activeIndex;
                                if (index >= tabs.length) {
                                    index = tabs.length - 1;
                                }
                                tabs.forEach(tab => tab.classList.remove('active'));
                                const activeTab = tabs[index];
                                activeTab && activeTab.classList.add('active');
                            }
                            if (swiper) {
                                swiper.slideTo(this.activeIndex);
                            }
                        }
                    }
                });
            }



            initProductTabList(groupElement) {
                const tabListEl = this.querySelector('[data-valentines-product-tab_list]');
                const tabs = groupElement.querySelectorAll('[data-vd-product-tab-name]');
                if (tabs .length === 0) return;
                tabs.forEach((tab, index) => {
                    tab.setAttribute('data-vd-product-tab', `${index}`);
                    tabListEl.appendChild(tab);
                    tab.addEventListener('click', () => {
                        tabs.forEach(t => t.classList.remove('active'));
                        tab.classList.add('active');
                        // 操纵一个swiper切换到另一个swiper对应的index
                        if (this.mySwiper) {
                            this.mySwiper.slideTo(index);
                        }
                    })
                });
                // 异步一下，先创建完productSwiper再创建tabSwiper
                setTimeout(() => {
                    this.initProductTabSwiper(tabListEl);
                    tabs[0].click();
                }, 0);
            }

            initProductTabSwiper(tabListEl) {
                const container = tabListEl.parentElement;
                if (this.productTabSwiper) this.productTabSwiper.destroy(true, true);
                this.productTabSwiper = new Swiper(container, {
                    slidesPerView: "auto",
                    spaceBetween: 0,
                    slidesPerGroup: 10,
                    loop: false,
                    navigation: {
                        nextEl: container.querySelector('.refurbished-swiper-tab-button-next'),
                        prevEl: container.querySelector('.refurbished-swiper-tab-button-prev'),
                    },
                    breakpoints: {
                        850: {
                            slidesPerGroup: 3
                        }
                    }
                });
            }
            getProductTabSwiper() {
                return this.productTabSwiper;
            }
        }
    );
}

